import React from 'react'
import { Row, Col } from 'reactstrap'
import { withTranslation } from 'react-i18next'
import { getPaginationInfo, processError } from '../../lib/lib'
import Pagination from 'react-js-pagination'
import NewsCard from '../../components/News/NewsCard.jsx'
import api from '../../api/api'
import { CaretLeft, CaretRight } from "phosphor-react"
import Cookies from 'universal-cookie'
import PropTypes from 'prop-types'
import Skeleton from '../../components/UI/Skeleton'
const cookies = new Cookies()

class News extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            page: 1,
            limit: 6,
            pages: 0,
            totalNews: 0,
            news: [],
            paginationRange: 5,
            newsLoaded: false,
        }
    }

    getNews(data) {
        return new Promise((resolve, reject) => {
            api.getNews(data)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    async changePage(page) {
        this.setState({ newsLoaded: false })
        await this.props.history.push(`/news/${page}`)
        const token = cookies.get('accessToken')
        const limit = this.state.limit
        const lang = this.props.i18n.language
        const { end, start } = getPaginationInfo({ page, limit })
        let arrPromise = [
            this.getNews({ token, lang, end, start }).then(({ rows }) => this.setState({ news: rows, page, newsLoaded: true })),
        ]
        Promise.all(arrPromise)
    }

    componentWillMount() {
        const token = cookies.get('accessToken')
        const page = this.props.match.params.page || 1
        const limit = this.state.limit
        const lang = this.props.i18n.language
        const { start, end } = getPaginationInfo({ page, limit })
        let arrPromise = [
            this.getNews({ token, lang, end, start }).then(({ rows, count }) => this.setState({ news: rows, totalNews: count, newsLoaded: true })),
        ]
        Promise.all(arrPromise)
    }

    render() {
        const { t } = this.props
        return (
            <div>
                <div className="content news-bg position-relative">
                    <Row className="w-100 m-0">
                        <Col xs={12} md={12} className="p-0">
                            <div className="page-title">
                                <div className="float-left">
                                    <h1 className="title news-dashboard xl-font-size">{t('news-news')}</h1>
                                </div>
                            </div>

                            <div className="col-xl-12">
                                <section>
                                    <div className="content-body news-bg">
                                        {' '}
                                        <div className="row px-15">
                                            {
                                                this.state.newsLoaded ?
                                                    this.state.news.map((news) => (
                                                        <NewsCard key={news.id}
                                                            id={news.id}
                                                            name={news.title}
                                                            date={news.date}
                                                            desc={news.desc}
                                                            props={this.props}
                                                            page={Number(this.props.match.params.page) || 1}
                                                            imgPreview={news.image}
                                                        />
                                                    ))
                                                    :
                                                    <React.Fragment>
                                                        <NewsCard skeleton={true} />
                                                        <NewsCard skeleton={true} />
                                                        <NewsCard skeleton={true} />
                                                        <NewsCard skeleton={true} />
                                                        <NewsCard skeleton={true} />
                                                        <NewsCard skeleton={true} />
                                                    </React.Fragment>
                                            }
                                        </div>
                                        {
                                            this.state.newsLoaded ?
                                                this.state.totalNews > this.state.limit ?
                                                    <Row className="pagination-row">
                                                        <Pagination
                                                            activePage={Number(this.props.match.params.page) || 1}
                                                            itemsCountPerPage={this.state.limit}
                                                            totalItemsCount={this.state.totalNews}
                                                            pageRangeDisplayed={this.state.paginationRange}
                                                            onChange={this.changePage.bind(this)}
                                                            itemClass={'page-item'}
                                                            disabledClass={'disabled'}
                                                            activeClass={'active'}
                                                            activeLinkClass={'active'}
                                                            linkClass={'page-link'}
                                                            itemClassFirst={'d-none'}
                                                            itemClassLast={'d-none'}
                                                            linkClassPrev={'arrow'}
                                                            linkClassNext={'arrow'}
                                                            nextPageText={<CaretRight size={16} />}
                                                            prevPageText={<CaretLeft size={16} />}
                                                        />
                                                    </Row> : ''
                                                :
                                                <Row className="pagination-row">
                                                    <Skeleton className="d-block mx-auto" width={200} height={30} />
                                                </Row>
                                        }
                                    </div>
                                </section>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

News.propTypes = {
    t: PropTypes.func,
    i18n: PropTypes.object,
    match: PropTypes.object,
    history: PropTypes.object,
}

export default withTranslation()(News)



// WEBPACK FOOTER //
// ./src/views/News/News.jsx